import React, { PureComponent } from 'react'
import { bool, func } from 'prop-types'
import noop from 'lodash/noop'
import Modal from '@active/react-ui/Modal'
import ModalBody from '@active/react-ui/ModalBody'
import ModalFooter from '@active/react-ui/ModalFooter'
import LinkAccountContent from '../../../common/LinkAccountContent'
import I18nMessage from '../../../common/I18nMessage'

class LinkAccount extends PureComponent {
  static propTypes = {
    isLinkAccountShow: bool,
    handleLinkAccountSubmit: func.isRequired,
    handleLinkAccountClose: func.isRequired,
    configureTrack: func,
  }

  static defaultProps = {
    configureTrack: noop,
    isLinkAccountShow: false,
  }

  componentDidMount() {
    const { configureTrack } = this.props
    configureTrack({
      eventName: 'LinkAccountModal init',
      widget: 'LinkAccountModal',
      pageType: 'LinkAccountModal',
    })
  }

  handleLinkAccountGoBack = () => {
    const { handleLinkAccountSubmit } = this.props
    handleLinkAccountSubmit({ submitAction: 'updateProfile' })
  }

  handleLinkAccountSigninToLink = ({ email, password }) => {
    const { handleLinkAccountSubmit } = this.props
    handleLinkAccountSubmit({
      email,
      password,
      submitAction: 'SigninToLink',
    })
  }

  render() {
    const {
      handleLinkAccountClose, isLinkAccountShow,
      ...rest
    } = this.props

    return (
      <Modal
        autoFocusClose
        shown={isLinkAccountShow}
        onClose={handleLinkAccountClose}
        className="passport-ui-app__modal passport__signin__linkAcount__modal-container"
        title={<I18nMessage id="passport.linkAccount.text.signinAndLinkAccount" />}
        size="md"
      >
        <LinkAccountContent
          {...rest}
          updateProfile={this.handleLinkAccountGoBack}
          signinToLink={this.handleLinkAccountSigninToLink}
          Body={ModalBody}
          Footer={ModalFooter}
        />
      </Modal>
    )
  }
}

export default LinkAccount
